// extracted by mini-css-extract-plugin
export default {"Flex":"styles_Flex__-fk9f","Flex-item":"styles_Flex-item__fhMyt"};